import ScreenComponent from "../../components/screenComponent";
import React from "react";
import {withRouter} from "react-router-dom";
import {faEye, faPlus} from "@fortawesome/pro-solid-svg-icons";
import DivTable from "../../components/divTable";
import {Get} from "../../components/request";
import screens from "../../screens";
import Moment from "moment";
import {Button} from "react-bootstrap";
import {getRoute} from "../../breadcrumb/utils";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

class Absences extends ScreenComponent {
    constructor(props) {
        super(props);

        this.state = {
            absences: []
        }
    }
    async componentDidMount() {
        super.componentDidMount();

        const {body} = await Get(`/v1/extranet/student/${screens.Absences}`);

        this.setState({
            absences: body
        });
    }
    render() {
        return (
            <>
                <section className="text-right">
                    <Button onClick={() => this.props.history.push(getRoute(screens.Absence).replace(':id', -1))} size="lg"
                            variant="outline-primary">
                        <FontAwesomeIcon className="text-success" icon={faPlus}/>
                        <span className="ml-2">Nouvelle absence</span>
                    </Button>
                </section>
                {this.state.absences.length > 0 && <section>
                    <DivTable columns={{
                        'Année académique': 'AnneeAcademiqueValeur',
                        'Date de début': x => Moment(x.AbsenceEtudiantDateDebut).format('DD/MM/YYYY'),
                        "Date de fin": x => Moment(x.AbsenceEtudiantDateFin).format('DD/MM/YYYY'),
                        "Suivi": "SuiviAbsenceValeur"
                    }}
                              array={this.state.absences}
                              actions={[{href: "absences/:id", icon: faEye, title: "Editer"}]}/>
                </section>}
            </>
        );
    }
}

export default withRouter(Absences);